import React, { Component } from 'react'

export default class LazyImg extends Component {

    constructor(props){
        super(props);
        this.state = {
            show: false
        };
        this.myRef = React.createRef();
        this.lazyload = this.lazyload.bind(this);
    }

    componentDidMount(){
        this.lazyload();
        window.addEventListener("scroll", this.lazyload);
    }

    lazyload(){
        let lazyImage = this.myRef.current;
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && !this.state.show) {
            this.setState({show: true});
        }
    }

    render() {
        let {alt, ...restprops} = this.props;
        return (
            <img {...restprops} alt={alt} ref={this.myRef} style={{display: `${this.state.show ? 'initial' : 'none'}`}} />
        )
    }

    componentWillUnmount(){
        window.removeEventListener("scroll", this.lazyload);
    }

}
